import React, { useEffect, useState } from 'react';
import EmployeeProcessService from "../services/EmployeeProcessService";
import { toast } from 'react-toastify';
import * as XLSX from 'xlsx';
import { useLoading } from '../Utils/LoadingContext';
import CustomDataTable from '../components/CustomDataTable'
const AttendancePivotReport = () => {
    const empcode = localStorage.getItem('empcode');
    const empcompany = localStorage.getItem('empCompany');
    // 🔹 Toggles for filters and table
    const [showFilters, setShowFilters] = useState(true);
    const [showTable, setShowTable] = useState(true);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);

    const { setLoading } = useLoading();

    const [filters, setFilters] = useState({
        CompanyName: '',
        PlantName: '',
        VenderName: '',
        DepartmentName: '',
        EmployeeCode: '',
        EmployeeName: '',
        Designation: '',
        Grade: '',
        DOJStart: '',  // must be valid ISO string like "2025-08-19"
        DOJEnd: '',
        EmployeeStatus: '1'
    });

    const [departments, setDepartments] = useState([]);
    const [plants, setPlants] = useState([]);
    const [company, setCompany] = useState([]);
    const [vender, setVender] = useState([]);

    useEffect(() => {
        loadDropdowns();
    }, []);

    const loadDropdowns = async () => {
        try {
            const [
                //deptRes, 
                plantRes, companyRes, venderRes] = await Promise.all([
                    // EmployeeProcessService.getDepartment(empcode),
                    EmployeeProcessService.getPlant(empcode),
                    EmployeeProcessService.getCompany('User'),
                    EmployeeProcessService.getVender('User')
                ]);
            //if (deptRes?.data?.statusCode === 200) setDepartments(deptRes.data.result);
            if (plantRes?.data?.statusCode === 200) setPlants(plantRes.data.result);
            if (companyRes?.data?.statusCode === 200) setCompany(companyRes.data.result);
            if (venderRes?.data?.statusCode === 200) setVender(venderRes.data.result);
        } catch (error) {
            console.error("Error loading dropdowns:", error);
        }
    };

    const formatHeader = (header) => {
        // If header is a date (yyyy-MM-dd), format nicely
        if (/^\d{4}-\d{2}-\d{2}$/.test(header)) {
            const date = new Date(header);
            return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        }
        return header
            .replace(/([A-Z])/g, ' $1')
            .replace(/_/g, ' ')
            .trim();
    };
    // 🔹 Load departments when Plant changes
    const handlePlantChange = async (e) => {
        const plantId = e.target.value;
        setFilters(prev => ({ ...prev, PlantName: plantId, DepartmentName: "" }));
        setDepartments([]);

        if (!plantId) return;

        try {
            const res = await EmployeeProcessService.getDepartment(empcode, plantId);
            if (res?.data?.statusCode === 200) {
                setDepartments(res.data.result);
            } else {
                setDepartments([]);
            }
        } catch (error) {
            console.error("Error loading departments:", error);
        }
    };
    const fetchData = async () => {
        try {
            // if (!filters.DOJStart || !filters.E) {
            //     alter("Please select From and To dates");
            //     return;
            // }

            setLoading(true);
            //alert('a');
            const response = await EmployeeProcessService.getAttendancePivotReport(filters);
            debugger;
            if (response.data.statusCode === 200 && response.data.rows.length > 0) {
                const result = response.data.rows;
                setData(result);
                setColumns(response.data.columns);
                setLoading(false);
                //toast.success("Data loaded");
            } else {
                setData([]);
                setColumns([]);
                setLoading(false);
                alert("No record found");
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            alert("No record found");
        } finally {
            setLoading(false);
        }
    };

    const applyFilters = () => {
        debugger;

        if (filters.CompanyName == "") {
            alert("Please select Company.");
            return;
        }
        // if (filters.PlantName =="") {
        //     alert("Please select Plant.");
        //     return;
        // }
        if (filters.DOJStart == "" && filters.DOJEnd == "") {
            alert("Please select Start date and end date.");
            return;
        }
        if (filters.DOJStart && filters.DOJEnd && filters.DOJStart > filters.DOJEnd) {
            alert("Start date cannot be after end date.");
            return;
        }
        fetchData();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters({ ...filters, [name]: value });
    };

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "AttendancePivotReport");
        XLSX.writeFile(workbook, "MusterRoll.xlsx");
    };

    return (
        <div className="container mt-1">
            {/* 🔹 Section 1: Heading */}
            <div className="mb-1 p-2 bg-light rounded">
                <h7 className="m-0 text-primary">Muster Roll Report</h7>
            </div>
            {/* 🔹 Section 2: Filters with toggle */}
            <div
                className="d-flex justify-content-between align-items-center mb-1 p-2 bg-secondary bg-opacity-10 rounded"
                style={{ cursor: "pointer" }}
                onClick={() => setShowFilters(!showFilters)}
            >
                <h7 className="m-0">Filters</h7>
                <span style={{ fontSize: "11px" }}>{showFilters ? "▲" : "▼"}</span>
            </div>
            {showFilters && (
                <>
                    <div className="row filter-section">
                        {/* Company */}
                        <div className="col-md-3">
                            <label className="filter-label text-primary">Select Company</label>
                            <select name="CompanyName" value={filters.CompanyName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Company</option>
                                {company.map(comp => (
                                    <option key={comp.id} value={comp.id}>{comp.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="filter-label text-primary">
                                Select Plant</label>
                            <select name="PlantName" value={filters.PlantName} onChange={handlePlantChange}
                                className="form-select filter-input">
                                <option value="">Select Plant</option>
                                {plants.map(plan => (
                                    <option key={plan.id} value={plan.id}>{plan.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="filter-label text-primary">
                                Select Vendor</label>
                            <select name="VenderName" value={filters.VenderName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Vendor</option>
                                {vender.map(ven => (
                                    <option key={ven.id} value={ven.id}>{ven.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="col-md-3">
                            <label className="filter-label text-primary">
                                Select Department</label>
                            <select name="DepartmentName" value={filters.DepartmentName} onChange={handleChange}
                                className="form-select filter-input">
                                <option value="">Select Department</option>
                                {departments.map(dept => (
                                    <option key={dept.id} value={dept.id}>{dept.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="row mb-3 filter-section">
                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    From</label>
                                <input
                                    type="date"
                                    name="DOJStart"
                                    value={filters.DOJStart}
                                    onChange={handleChange}
                                    className="form-control filter-input" />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    To</label>
                                <input
                                    type="date"
                                    name="DOJEnd"
                                    value={filters.DOJEnd}
                                    onChange={handleChange}
                                    className="form-control filter-input" />
                            </div>
                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    Employee Code</label>
                                <input
                                    name="EmployeeCode"
                                    value={filters.EmployeeCode}
                                    placeholder="Employee Code"
                                    onChange={handleChange}
                                    className="form-control filter-input"
                                />
                            </div>

                            <div className="col-md-3">
                                <label className="filter-label text-primary">
                                    Employee Name</label>
                                <input
                                    name="EmployeeName"
                                    value={filters.EmployeeName}
                                    placeholder="Employee Name"
                                    onChange={handleChange}
                                    className="form-control filter-input"
                                />
                            </div>
                            <div className="col-md-3">
                                <label className="text-primary">Employee Status</label>
                                <select className="form-select" name="EmployeeStatus" value={filters.EmployeeStatus} onChange={handleChange}>
                                    {/* <option value="">Employee Status</option> */}
                                    <option value="1">Active</option>
                                    <option value="0">In Active</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-2 mb-3 flex-wrap">
                        <button className="btn btn-primary filter-btn" onClick={applyFilters}>Search</button>
                        {data.length > 0 && (
                            <button className="btn btn-success filter-btn" onClick={downloadExcel}>Download Excel</button>
                        )}
                    </div>
                </>
            )}

            {/* 🔹 Section 3: Data Table with toggle */}
            <div
                className="d-flex justify-content-between align-items-center mb-1 p-1 bg-secondary bg-opacity-10 rounded"
                style={{ cursor: "pointer" }}
                onClick={() => setShowTable(!showTable)}
            >
                <h7 className="m-0">Data</h7>
                <span style={{ fontSize: "11px" }}>{showFilters ? "▲" : "▼"}</span>
            </div>

            {showTable && (
                <div className="table-responsive">
                    <CustomDataTable data={data} title="Employee List" />
                </div>
            )}
        </div>
    );
};

export default AttendancePivotReport;
